/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteMetadataSubdataUnique = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable={true} />} value={option.uuid} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_METADATA_SUBDATA_UNIQUE">
      <SelectionSet
        name="deleteMetadata_subdata_unique"
        alias="deleteMetadataSubdataUnique"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteMetadataSubdataUnique: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
